// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1ZnMa","right":"styles_right__LgU_g"};